import { Field } from 'redux-form';
import React from 'react';
import { useIntl } from 'react-intl';
import { connectionStatusFormOptions } from 'common/formOptions';
import { getName } from 'common/personUtils';
import SelectTypeField from '../SelectTypeField';

const PatientSearchFilters = ({
  showProviderOptions = true,
  showBillingOptions = true,
  showConnectionOptions = true,
  orderingProviderOptions = [],
  billingCodeOptions = [],
  connectionOptions = connectionStatusFormOptions,
  onClear,
  onSelected,
  styles,
  isLoading,
  searchParams = {},
}) => {
  const {
    filterByOrderingPhysicianID,
    filterByBillingCodeID,
    filterByConnectionStatus,
  } = searchParams;
  const intl = useIntl();
  const orderingProviderOptionsWithNone = [
    {
      id: 'none',
      lastName: intl.formatMessage({
        id: 'search.SearchForm.RefineFilters.NoOrderingProvider',
      }),
    },
    ...orderingProviderOptions,
  ];
  const billingCodeOptionsWithNone = [
    {
      id: 'none',
      name: intl.formatMessage({
        id: 'search.SearchForm.RefineFilters.NoBillingCode',
      }),
    },
    ...billingCodeOptions,
  ];

  return (
    <div className={styles.searchBarFilters}>
      {showProviderOptions && (
        <div className={styles.searchBarFilterWrapper}>
          <Field
            component={SelectTypeField}
            name="filterByOrderingPhysicianID"
            className="orderingProviderFieldSelector searchBarFilterSelectors react-select-filter-selector"
            placeholder="Ordering Provider"
            options={orderingProviderOptionsWithNone}
            getOptionLabel={d => getName(d.firstName, d.lastName, '')}
            getOptionValue={d => d.id}
            getSelectedOption={value => {
              return orderingProviderOptionsWithNone.filter(
                o => o.id === value,
              );
            }}
            selectedValue={filterByOrderingPhysicianID}
            isOptionSelected={() => false}
            isClearable
            onClear={onClear}
            onSelect={onSelected}
            isSearchable
            isLoading={isLoading}
            styles
          />
        </div>
      )}
      {showBillingOptions && (
        <div className={styles.searchBarFilterWrapper}>
          <Field
            component={SelectTypeField}
            name="filterByBillingCodeID"
            className="billingCodeFieldSelector searchBarFilterSelectors react-select-filter-selector"
            placeholder="Billing Code"
            options={billingCodeOptionsWithNone}
            getOptionLabel={d => d.name}
            getOptionValue={d => d.id}
            getSelectedOption={value => {
              return billingCodeOptionsWithNone.filter(o => o.id === value);
            }}
            selectedValue={filterByBillingCodeID}
            isOptionSelected={() => false}
            isClearable
            onClear={onClear}
            onSelect={onSelected}
            isSearchable
            isLoading={isLoading}
            styles
          />
        </div>
      )}
      {showConnectionOptions && (
        <div className={styles.searchBarFilterWrapper}>
          <Field
            component={SelectTypeField}
            name="filterByConnectionStatus"
            className="connectionsFieldSelector searchBarFilterSelectors react-select-filter-selector"
            placeholder="Connection"
            selectedValue={filterByConnectionStatus}
            options={connectionOptions}
            isClearable
            onClear={onClear}
            onSelect={onSelected}
            isSearchable
            styles
          />
        </div>
      )}
    </div>
  );
};
export default PatientSearchFilters;



// WEBPACK FOOTER //
// ./src/views/components/Search/PatientSearchFilters.jsx